import React, { useState } from 'react'

import { Box, Typography, Grid, Button } from '@material-ui/core'

import { TrendingFlatOutlined } from '@material-ui/icons'
import { useWindowSize } from '@yapay/react-components/hooks'
import PaperHeader from './components/PaperHeader'
import PlanSettings from './components/PlanSettings'

import CardPlan from 'views/Subscribe/components/CardPlan'
import ContractPlanMigrateContext from 'contexts/ContractPlanMigrateContext'
import { useParams, useHistory } from 'react-router-dom'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import { routes } from 'routes'
import { reverse } from 'named-urls'
import ModalSuccess from 'components/ModalSuccess'

const MigrationConfirm = () => {
  const context = React.useContext(ContractPlanMigrateContext)
  const windowSize = useWindowSize()
  const snackbar = useSnackbar()
  const params = useParams()
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    onCancel()
  }

  const onCancel = () => {
    history.push(
      reverse(routes.contracts.show, {
        contractId: params.contractId,
      }),
    )
  }

  const updatePlan = async () => {
    setLoading(true)
    try {
      await service.recurrence.contractPlans.update({
        contractId: params.contractId,
        contractPlanId: params.contractPlanId,
        contractPlan: context.data.newPlan,
      })
      handleOpen()
    } catch {
      snackbar.open({
        message: 'Falha ao migrar o plano!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box p={{ xs: 2, sm: 4 }}>
      <PaperHeader title="Cofirmação de migração de plano" />
      <Box mt={4}>
        <Grid container alignItems="center">
          <Grid item xs={12} sm={3}>
            <Box px={{ xs: 3, sm: 0 }}>
              <Typography variant="h6" color="primary" mb={2}>
                Plano antigo
              </Typography>
              <Box mt={2}>
                <CardPlan plan={context.data.oldPlan} hideInfoMobile />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2} container justify="center">
            {windowSize.isDesktop ? (
              <TrendingFlatOutlined
                color="disabled"
                style={{ fontSize: '5rem' }}
              />
            ) : (
              <Box mt={3}>
                <TrendingFlatOutlined
                  color="disabled"
                  style={{ fontSize: '5rem', transform: 'rotate(90deg)' }}
                />
              </Box>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box px={{ xs: 3, sm: 0 }}>
              <Typography variant="h6" color="primary">
                Plano novo
              </Typography>
              <Box mt={2}>
                <CardPlan plan={context.data.newPlan} hideInfoMobile />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box my={6}>
        <Typography variant="h4" color="textSecondary">
          Configurações do novo plano
        </Typography>
        <PlanSettings plan={context.data.newPlan} />
      </Box>

      <ModalSuccess open={open} onClose={handleClose}>
        Migração de plano com sucesso!
      </ModalSuccess>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            fullWidth
            disabled={loading}
            onClick={updatePlan}
          >
            OK, MIGRAR PLANO
          </Button>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            fullWidth
            onClick={onCancel}
          >
            CANCELAR
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default MigrationConfirm
